/* istanbul ignore file */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AoFooterComponent } from './ao-footer/ao-footer.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [AoFooterComponent],
  exports: [AoFooterComponent],
  imports: [CommonModule, RouterModule],
})
export class SharedAoComponentsModule {}
